import React, { useEffect, useLayoutEffect, useRef, useState } from "react"
import { IconButton } from "@mui/material"
import { rootStore } from "store/RootStore"
import LiveIndicator from "img/icons/liveInSearch.svg"
import Play from "img/icons/playInSearch.svg"
import LinearProgress from "@mui/material/LinearProgress"
import serieLogo from "img/icons/series.svg"
import { observer } from "mobx-react"
import { CALLING_CONTEXT_TYPE } from "store/page/OverlayEventDetails"
import { FilterEventTypeBar } from "scenes/Search/components/FilterTypeEventBar"
// import goBack from "img/icons/search/arrow_back_ios_white_36dp.svg"
// import goForward from "img/icons/search/arrow_forward_ios_white_36dp.svg"
import { NotFound, NOTFOUND_TYPE } from "./../Search"
import { FilterBar } from "scenes/Search/components/FilterBar"
import { moment } from "store/util/moment"
import { getUpcomingLabelName } from "utils/Utils"
import { CircularProgress } from "@mui/material"
import { dateAndTime, eventType, endTs, startTs, durationInPercent } from "utils/EventHelpers"
import { l10n } from "store/lang/L10n"
import adultContent from "img/fallback/adult_content.png"
import PinLock from "img/icons/pin_protected.svg"
import {useAdultPinGuard} from "hooks/useAdultPinGuard"
import { analyticsScreen, analyticsMeta, analyticsProgramDetailsSource } from "store/qlapi/LogService"


import "./SearchComponents.css"
import "./../../Search/SearchStyle.css"
import "scenes/components/EpisodeAndRelatedTile.css"

const Programs = observer(({ id, item, recordingsType, page, typeCards, serieId }) => {
	//console.debug("Programs series %o, type %o, page %o, typeCards %o", item, recordingsType, page, typeCards )

	// this will do a re-render after a interactionEvent that calls getBookmarksAsync via notifyStopped
	useEffect(() => {
		//console.debug("useEffect Programs", rootStore.page.CoCoBookmarks.refreshCount, item)
	}, [rootStore.page.CoCoBookmarks.refreshCount])

	const cocoBookmarks = rootStore.page.CoCoBookmarks
	const [bookmarkInfo, setBookmarkInfo] = useState(null)

	const _EVENT_DATA = {
		logoImgSrc: null,
		channelName: null,
		eventTitle: null,
		genres: null,
		seasonInfo: null,
		programDate: null,
		liveIcon: null,
		progressBar: null,
		playButton: null,
		seriesMobileIcon: null,
		type: null,
		idEvent: null,
		idSerie: null,
	}
	const backGroundImgStyle = { ...page.backGroundImgStyle }

	const loadData = () => {
		//console.debug("event= 3", item?.event)
		cocoBookmarks.getBookmarkAsync(null, false, item?.event?.id).then((bm) => {
			if (bm && !isLiveEvent && bm.position !== bookmarkInfo?.position) {
				// MTVW-899: don't hide anymore
				//const bmProgress = bm.hidden ? null : 100 * (bm.position - startTs(item?.event)) / (endTs(item?.event) - startTs(item?.event))
				const bmProgress = 100 * (bm.position - startTs(item?.event)) / (endTs(item?.event) - startTs(item?.event))
				setBookmarkInfo({ progress: bmProgress, id: item?.event?.id, position: bm.position })
			}
			else if (bookmarkInfo && !bm) setBookmarkInfo(null)
		})
		//console.debug("backgroundImage", "series", item)
		const backgroundImage = rootStore.channelsService?.isChannelPinProtected(item?.event?.channelId) ?
			adultContent : item?.content?.posterUrl

		backGroundImgStyle.backgroundImage = `${page.gradientImg},url(${backgroundImage}?mode=box&w=480&h=270)`
		const isLiveEvent = eventType(item?.event) === "c" ? true : false
		const isPastEvent = eventType(item?.event) === "p" ? true : false

		const season = item?.content?.season ? `S${item?.content?.season}` : ""
		const episode = item?.content?.episode ? `E${item?.content?.episode}` : ""
		_EVENT_DATA.seasonInfo = `${season} ${episode} `

		const title = item?.content?.episodeName ? item?.content?.episodeName : ""
		// MTVW-624: don't display item.content.title
		//_EVENT_DATA.eventTitle = `${season !== "" || episode !== "" ? (title !== "" ? "\u25CF" : "") : item.content.title} ${title}`
		_EVENT_DATA.eventTitle = `${season !== "" || episode !== "" ? (title !== "" ? "\u25CF" : "") : ""} ${title}`

		_EVENT_DATA.idEvent = item?.event?.id
		_EVENT_DATA.logoImgSrc = page.getChannelLogo(item?.event?.channelId)
		_EVENT_DATA.channelId = item?.event?.channelId
		_EVENT_DATA.channelName = (
			<div className="searchChannelName" data_test="search_channel_name">
				{page.getChannelName(item?.event?.channelId)}
			</div>
		)

		_EVENT_DATA.genres = item?.content?.genres?.join(" \u25CF ")
		//_EVENT_DATA.genres = _EVENT_DATA.eventTitle ? "" : item?.content?.genres?.join(" \u25CF ")
		_EVENT_DATA.programDate = dateAndTime(item?.event)
		_EVENT_DATA.seriesMobileIcon = (
			<div style={{ position: "relative" }}>
				<img className="searchSeriesMobileIcon" src={serieLogo} alt="series" data_test="search_event_series_icon"></img>
			</div>
		)
		// MTVW-976: replaced
		//_EVENT_DATA.liveIcon = isLiveEvent ? <img src={LiveIndicator} className="searchLiveIndicator" data_test="search_event_live_icon" alt="" /> : null
		const isRecording = () => {
			const recMarker = rootStore.page.Recordings.Manager.getMarker(item?.event?.id ?? item?.data?.event?.id)
			// MTVW-1016: TODO, check
			//console.debug("recMarker=", recMarker)
			return recMarker
		}
		const profileName = () => {
			const marker = rootStore.page.Recordings.Manager.getMarker(item?.event?.id ?? item?.data?.event?.id)
			return marker?.ProfileId !== rootStore?.sso?.profile?.id ? rootStore.sso.getProfile(marker?.ProfileId)?.name : null
		}
		_EVENT_DATA.recording = isRecording() ?
			<div style={{ display: "flex", position: "absolute", left: 3, bottom: 28 }} className="recordingIndicator">
				<div className="recordingStatusIndicator">
					<div className="recordingStatusShape" />
				</div>
				{profileName() &&
					<div style={{ maxWidth: 190, fontSize: 16, fontFamily: "EuropaRegular", color: "rgba(255,255,255,0.8)" }} className="recordingProfileName">{profileName()}</div>
				}
			</div>
			: null
		_EVENT_DATA.progressBar = isLiveEvent ? (
			<LinearProgress
				classes={{ root: "searchMuiLinearProgress" }}
				variant="determinate"
				value={Math.max(0, Math.min(100, Math.round(durationInPercent(item.event))))}
				data-test="search_event_progressbar"
			/>
		) : null
		/*
		_EVENT_DATA.playButton =
			(isLiveEvent || isPastEvent) && page.isReplayAllowed(item?.event) ? (
				<div style={{ position: "relative" }}>
					<img className="searchPlayIcon" src={Play} alt="play" data_test="search_event_play_icon" style={{ bottom: isLiveEvent || bookmarkInfo?.id === item?.event?.id ? "10px" : "-1px" }}
						onClick={(e) => {
							// MTVW-624: autoplay support
							e.stopPropagation()
							// MTVW-629: close overlay if liveTv
							// setShow first so that derived 'origin' is correct
							rootStore.page.OverlayEventDetails.setShow(!rootStore.page.Player.playerLiveTvVo.isPlayerActive, CALLING_CONTEXT_TYPE.Search)
							rootStore.page.OverlayEventDetails.setEpgEventById(_EVENT_DATA.idEvent, true, { [analyticsMeta.screen]: analyticsScreen.programDetails, source: analyticsProgramDetailsSource.seriesRelatedPrograms }).then((res) => {
								rootStore.page.OverlayEventDetails.setComponentType('event')
							})
						}}></img>
				</div>
			) : null
		*/
		_EVENT_DATA.liveIcon = isLiveEvent ? <div style={{ right: 1, position: 'relative' }}>
			<div className="searchLiveIcon">
				<div className="liveFrame">
					<div className="liveContainer">
						<div className="liveEllipse" />
					</div>
					<div className="liveLabel">{l10n.featureSearchLiveResult}</div>
				</div>
			</div>
		</div> : null
		_EVENT_DATA.hasUpcomingLabel = () => {
			let start = null
			if (item?.event) start = startTs(item?.event)
			else start = startTs(item?.data?.event)
			if (!start) debugger
			//console.debug("hasUpcomingLabel series", item)
			return getUpcomingLabelName(start)
		}
	}

	if (item) loadData()
	else return null

	
	// MTVW-1094: PlayerCover for protected adult content
	const { handleProtectedClick, PinGuardElement } = useAdultPinGuard(() => {
		// MTVW-629: isPlayerPresent needs to be false in order to display event 
		rootStore.page.OverlayEventDetails.setIsPlayerPresent(false)
		rootStore.page.OverlayEventDetails.setShow(true, CALLING_CONTEXT_TYPE.Search)
		// setShow first so that derived 'origin' is correct
		rootStore.page.OverlayEventDetails.setEpgEventById(_EVENT_DATA.idEvent, false, { [analyticsMeta.screen]: analyticsScreen.programDetails, source: analyticsProgramDetailsSource.seriesRelatedPrograms }).then((res) => {
			rootStore.page.OverlayEventDetails.setComponentType("event")
			// MTVW-624: combined activityStack for related content and search
			// MTVW-1078, item 9: add subitem
			rootStore.page.OverlayEventDetails.pushActivity({ type: page.CATEGORY_SERIES, idSerie: serieId, subItem: page.seasonSelected})
		})
	})

	return (
		<>
		{PinGuardElement}
		<div id={id}
			className="eventContainer"
			data_test="search_event"
			onClick={(e) => {
				e.stopPropagation()
				// MTVW-629: isPlayerPresent needs to be false in order to display event 
				handleProtectedClick(page.getChannel(_EVENT_DATA.channelId))
			}}
		>
			<div className="searchEventLogoChannel">
				<img className="searchLogoChannel" src={_EVENT_DATA.logoImgSrc} alt="channel logo"></img>
			</div>
			<div className="searchEventInfoContainer">
				<div className="searchEventInfo">
					<div className="searchEventInfoText">
						{_EVENT_DATA.channelName}
						{rootStore.channelsService?.isChannelPinProtected(_EVENT_DATA.channelId) ?
							<div style={{display: "flex", flexDirection: "row", marginTop: 26}}>
								<img style={{ width: 20, height: 20, marginTop: 7, marginRight: 10 }} src={PinLock}></img>
								<div className="searchEventTitle" data_test="search_event_title">{l10n.featureContentPinProtected}</div>
							</div>
							:
							<div className="searchEventTitle" data_test="search_event_title">
								{_EVENT_DATA.seasonInfo}
								{_EVENT_DATA.eventTitle}
							</div>
						}
						{/* <div className="searchEventGenresInfo">{_EVENT_DATA.genres}</div> */}
					</div>
					<div className="searchEventInfoPoster">
						<div className="eventPosterSection" style={backGroundImgStyle} data_test="search_event_poster"></div>
					</div>
				</div>
				<div className="searchEventIconsAndBar">
					{!rootStore.channelsService?.isChannelPinProtected(_EVENT_DATA.channelId) &&
						<>
							{/* MTVW-976: replaced, see below
							{_EVENT_DATA.liveIcon}
							*/}
							{_EVENT_DATA.recording}
							<span data_test="search_event_info">{_EVENT_DATA.programDate}</span>
							{_EVENT_DATA.progressBar}
							{bookmarkInfo && bookmarkInfo.id === item?.event?.id &&
								<LinearProgress
									classes={{ root: "searchMuiLinearProgress" }}
									variant="determinate"
									value={Math.max(0, Math.min(100, Math.round(bookmarkInfo.progress)))}
									data-test="search_event_progressbar"
								 />
							}
							{/* MTVW-976: replaced with _EVENT_DATA.liveIcon
							{_EVENT_DATA.playButton}
							*/}
							{_EVENT_DATA.liveIcon}
							{_EVENT_DATA.hasUpcomingLabel && _EVENT_DATA.hasUpcomingLabel() &&
								<div style={{ bottom: 10, right: 10 }} className="upcomingIndicator">
									<div className="upcomingLabel">{_EVENT_DATA.hasUpcomingLabel()}</div>
								</div>
							}
						</>
					}
				</div>
			</div>
		</div>
		</>
	)
})

export const SeriesComponent = observer((props) => {
	const page = rootStore.page.Search
	const pageOverlay = rootStore.page.OverlayEventDetails
	const refListSeriesContainer = useRef()

	const allEpisodes = []

	const [loaded, setLoaded] = useState(false)

	useEffect(() => {
		// MTVW-965: don't report
		//rootStore.logService.analyticsScreenview({ [analyticsMeta.screen]: analyticsScreen.search })
	}, [])

	useEffect(() => {
		const centerTileRect = document.getElementById("centerTile")?.getBoundingClientRect()
		const startRect = document.getElementById("s_0")?.getBoundingClientRect()
		if (centerTileRect && startRect) {
			//console.debug("GOT centerTile", refListSeriesContainer?.current?.scrollTop, refListSeriesContainer?.current?.clientHeight, refListSeriesContainer?.current?.scrollHeight, centerTileRect, startRect)		
			setTimeout(() => {
				//console.debug("moving to", centerTileRect?.top - startRect?.top)
				if (refListSeriesContainer?.current) {
					refListSeriesContainer.current.scrollTop = centerTileRect?.top - startRect?.top - refListSeriesContainer?.current?.clientHeight / 2 + startRect?.height / 2 + 20
				}
			}, 300)
		}
	})

	useLayoutEffect(() => {
		//console.debug("useLayoutEffect")
		if (!page.episodeSelectedId) page.setRefresh(true)
		// MTVW-629: set to ALL_SEASON_SELECTED, otherwise there might be no search results
		// MTVW-629: set to FILTER_EVENT_LIVE_REPLAY
		//if (!page.scrollposSelected) page.setSeasonSelected(page.ALL_SEASON_SELECTED)
		// MTVW-1011: if recordings is selected in the overview then directly select FILTER_EVENT_RECORDINGS
		//console.debug("fromCategory", props.fromCategory)
		
		// MTVW-1016 item 4, poppedFilterEventType
		if (page.poppedFilterEventType) {
			page.setFilterEventType(page.poppedFilterEventType)
			page.setPoppedFilterEventType(null)
		}
		else if (props?.fromCategory === page.CATEGORY_RECORDINGS) {
			page.setFilterEventType(page.FILTER_EVENT_RECORDINGS)
		}
		else {
			//console.debug("fromCategory", props.fromCategory)
			page.setFilterEventType(page.FILTER_EVENT_LIVE_REPLAY)
		}
		setLoaded(false)
		page.getSeries(props.seriesId).then((res) => {
		})
		.catch((err) => {
			console.error("useLayoutEffect getSeries", err)
		}).finally(() => {
			setLoaded(true)
		})
	}, [page, props.seriesId])

	// the code below is necessary to refresh the data
	useEffect(() => {
		if (!page.episodeSelectedId) refListSeriesContainer?.current?.scrollTo?.(0, 0)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [page.series, page.seasonSelected])

	if (!page.episodeSelectedId) page.setRefresh(false)
	// end code for refresh

	if (page.seasonSelected === page.ALL_SEASON_SELECTED) {
		// eslint-disable-next-line no-unused-expressions
		page.series?.seasons?.forEach((season) => {
			// eslint-disable-next-line no-unused-expressions
			season.episodes?.forEach((episode) => {
				allEpisodes.push(episode)
			})
		})
	} else {
		// eslint-disable-next-line no-unused-expressions
		page.series?.seasons?.forEach((season) => {
			//console.debug("seasonSelected", page.seasonSelected, season.number.toString())
			if (page.seasonSelected === season.number.toString()) {
				season.episodes?.forEach((episode) => {
					allEpisodes.push(episode)
				})
			}
		})
	}

	const filterSeries = () => {
		//console.debug("filteredSeries", page.applyTabFilter(allEpisodes), page.filterEventType)
		const filtered = page.applyTabFilter(allEpisodes, page.filterEventType)
		//console.debug("filterSeries=", page.filterEventType, filtered)
		if (filtered)
			return filtered.map((item, index) => {
				// MTVW-624: scroll to top on tab change
				refListSeriesContainer?.current?.scrollTo?.(0, 0)
				// mark id of episodeSelectedId for scroll position
				let id = "s_" + index
				//console.debug("filterSeries=", item.event.id, page.episodeSelectedId)
				if (item.event.id === page.episodeSelectedId) {
					console.debug("Hit Programs=", index, item, page.episodeSelectedId)
					id = "centerTile"
				}
				// MTVW-1011-fix: props.idSerie -> props.seriesId
				return <Programs id={id} item={item} page={page} typeCards={page.categorySelected} key={`${page.categorySelected}-${index}`} serieId={props.seriesId} />

			})
		else return null
	}
	/*
	const visibility = pageOverlay.activityStack.length > 0 ? "visible" : "hidden"
	console.debug("pageOverlay", pageOverlay.activityStack.length, pageOverlay.activityStack.length > 0 ? "visible" : "hidden", pageOverlay)
	*/

	const ButtonsComponent = 
		<>
			{/* MTVW-624: combined activityStack for related content and search */}
			<IconButton
				aria-label="Back"
				disableRipple={true}
				disableFocusRipple={true}
				className="seriesComponentBackButton"
				onClick={(e) => {
					e.preventDefault()
					e.stopPropagation()
					// MTVW-624: combined activityStack for related content and search
					pageOverlay.restoreActivity()
					// reset filter
					// MTVW-1078, item 9: commented out to keep the selected genre/season when going back
					//page.setSeasonSelected(page.ALL_SEASON_SELECTED)
					//page.setGenresSelected(page.ALL_GENRES_SELECTED)
					// MTVW-620: FILTER_EVENT_ALL -> FILTER_EVENT_LIVE_REPLAY
					page.setFilterEventType(page.FILTER_EVENT_LIVE_REPLAY)
				}}
				data-test="back_series_component"
				style={{ visibility: pageOverlay.activityStack.length > 0 ? "visible" : "hidden" }}
			></IconButton>
			<IconButton
				aria-label="Close"
				disableRipple={true}
				disableFocusRipple={true}
				className="seriesComponentCloseButton"
				onClick={() => {
					// MTVW-624: combined activityStack for related content and search
					// MTVW-1016 item 11: added setSeriesId(null) to prevent display of previous series search result 
					pageOverlay.setSeriesId(null)
					pageOverlay.resetActivity()
					pageOverlay.setShow(false)
					// MTVW-1078, item 6: prevent intermittent re-display when opening an event
					pageOverlay.setComponentType(null)
					// reset filter
					page.setSeasonSelected(page.ALL_SEASON_SELECTED)
					page.setGenresSelected(page.ALL_GENRES_SELECTED)
					// MTVW-620: FILTER_EVENT_ALL -> FILTER_EVENT_LIVE_REPLAY
					page.setFilterEventType(page.FILTER_EVENT_LIVE_REPLAY)
				}}
				data-test="close_series_component"
			></IconButton>
		</>

	return (
		<>
		{loaded ?
			<div className="seriesComponentMainContainer">
				<div className="seriesComponentTitleContainer">
					<div className="seriesComponentButtonsContainer">
						{ButtonsComponent}
					</div>
					<div className="seriesComponentTitle" data_test="search_series_name">
						{page?.series?.title}
					</div>
					<div className="seriesComponentFilterSeriesContainer">
						{/* <FilterSeason page={page} /> */}
						<FilterBar page={page} filterType={page.CATEGORY_SERIES} />
					</div>
					<FilterEventTypeBar page={page} items={allEpisodes} />
				</div>
				{
					page.applyTabFilter(allEpisodes, page.filterEventType) ? (
						<div className="seriesComponentListContainer" ref={refListSeriesContainer}>
							{filterSeries()}
						</div>
					) : page?.series ? (
						<NotFound type={NOTFOUND_TYPE.NOHINT} />
					) : (
						<></>
					)
				}
				{/*
				{page?.series && !page?.series?.seasons?.length > 0 ?
					<NotFound />
					: <></>
				}
				*/}
			</div>
			:
			<div className="seriesComponentMainContainer">
				<div className="seriesComponentTitleContainer">
					<div className="seriesComponentButtonsContainer">
						{ButtonsComponent}
					</div>
					<div className="seriesComponentTitle" data_test="search_series_name">
						{props.seriesTitle}
					</div>
				</div>
				<div style={{ display: "flex", justifyContent: "center", position: "relative", top: 50/*margin: "0 auto", height: 282, width: 282, position: "absolute"*/ }}>
					<CircularProgress size={70} />
				</div>
			</div>
		}
	</>
	)
})
